import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function AttractionCard({ poi, key, language }) {
  const [fontSize, setFontSize] = useState("17px");
  const [lineHeight, setLineHeight] = useState("2");
  const lang = language || "en";

  useEffect(() => {
    const handleResize = () => {
      if (window.matchMedia("(max-width: 640px)").matches) {
        setFontSize("10px");
        setLineHeight("2");
      } else {
        setFontSize("18px");
        setLineHeight("2");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function truncateText(text, maxLength) {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  }

  // Process description immediately
  const currentDescription = lang === "ar" ? poi.ar_shortDescription : poi.shortDescription;
  const styledDescription = currentDescription?.replace(
    /<span[^>]*>/g,
    `<span style="font-size: ${fontSize}; line-height: ${lineHeight};">`
  ).replace(
    /<p[^>]*>/g,
    `<p style="font-size: ${fontSize}; line-height: ${lineHeight};">`
  ) || "";

  let url = `${poi.slug}-${poi?.cityData?.name}-${poi?.countryData?.name}-poi-${poi._id}`;
  let url2 = url.toLowerCase().replace(/\s+/g, "-");
  let city = poi?.cityData?.name;
  let city2 = city.toLowerCase().replace(/\s+/g, "-");

  const path = lang === "ar"
    ? `/ar/place/${city2}/${url2}`
    : `/en/place/${city2}/${url2}`;

  return (
    <Link
      to={path}
      key={key}
      dir={lang === "ar" ? "rtl" : "ltr"}
      className="lg:w-[404px] max-sm:w-[85%] flex-none cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    >
      <div>
        <img
          loading="lazy"
          src={poi?.images[0]}
          className="lg:w-[404px] max-sm:w-[96%] lg:h-[280px] max-sm:h-[200px] rounded-md hover:shadow-xl"
          alt={poi?.title || poi?.ar_title}
        />
      </div>
      <div className="py-4">
        <p className="text-[20px] max-sm:text-[15px]">
          <b className="text-[25px] font-semibold max-sm:text-[20px]">
            {lang === "ar" ? poi.ar_title : poi.title},{" "}
          </b>
          {lang === "ar" ? poi?.stateData?.ar_name : poi?.stateData?.name}
        </p>
        <div
          className="lg:mt-5 max-sm:mt-3 max-sm:w-[95%] text-[17px] max-sm:text-[10px] lg:leading-5 max-sm:leading-3"
          dangerouslySetInnerHTML={{
            __html: truncateText(styledDescription, lang === "ar" ? 130 : 300)
          }}
        />
      </div>
    </Link>
  );
}

export default AttractionCard;
